/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function GroupsSearchViewController(
    this: JS5Object,
    $location: JS5Object,
    $q: JS5Object,
    uiGridConstants: JS5Object,
    GroupsService: JS5Object,
    ModalService: JS5Object,
    NavbarUtilService: JS5Object,
    PaginationService: JS5Object,
    PermissionsService: JS5Object,
    SearchFilterService: JS5Object,
) {
    const getData = () => {
        let criteria = {
            fetchOffset: this.pagingOptions.pageSize * (this.pagingOptions.currentPage - 1),
            fetchLimit: this.pagingOptions.pageSize,
            includeUsers: true,
            searchString: $location.search().searchText
        };

        this.loadingIndicator.show = true;
        $q.all({
            groups: GroupsService.getAllGroups(criteria),
            isSystemOps: PermissionsService.isSystemOperator()
        }).then((data: JS5Object) => {
            let writeGroupPromises: JS5Object[] = [];
            _.forEach(PaginationService.pageData, (group: JS5Object) => {
                if (data.isSystemOps) {
                    group.hidden = false;
                } else {
                    writeGroupPromises.push(GroupsService.isSystemOperatorGroup(group.id).then((isSystemOpsOnly: boolean) => {
                        group.hidden = isSystemOpsOnly;
                    }));
                }
            });
            this.gridOptions.data = PaginationService.pageData;
            return $q.all(writeGroupPromises);
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    const deleteGroup = () => {
        let groupId = this.gridApi.selection.getSelectedRows()[0].id;
        ModalService.showMessageModal({
            messageText: 'Are you sure you want to delete this Group?',
            pullCancelLeft: true,
            title: 'Delete Group',
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, () => {
            this.loadingIndicator.show = true;
            GroupsService.deleteGroup(groupId).then(() => {
                getData();
            }).finally(() => {
                this.loadingIndicator.show = false;
            });
        });
    };

    const paginationPreviousPageHandler = () => {
        --this.pagingOptions.currentPage;
        getData();
    };

    const paginationNextPageHandler = () => {
        ++this.pagingOptions.currentPage;
        getData();
    };

    const paginationPageSizeChanged = () => {
        this.pagingOptions.currentPage = 1;
        getData();
    };

    const navigateToEditView = (entity: JS5Object) => {
        const groupId = _.get(entity, 'id') || _.get(this.gridApi.selection.getSelectedRows()[0], 'id');
        $location.url(`system/groups/edit/${groupId}`);
    };

    const canEditSelection = () => {
        let selection = this.gridApi.selection.getSelectedRows();
        return !!selection.length && !selection[0].hidden;
    };

    const columnDefinitions = [
        {
            field: 'name',
            displayName: 'Name',
            sort: {
                direction: 'asc',
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'users.length',
            displayName: 'Users',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];

    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: false,
        columnDefs: columnDefinitions,
        onRegisterApi: (gridApi: JS5Object) => {
            this.gridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };

    this.onRowDblClick = (row: JS5Object) => {
        if (!row.entity.hidden) {
            navigateToEditView(row.entity);
        }
    };

    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: () => true,
            onClick: () => {
                navigateToEditView({id: -1});
            }
        },
        {
            label: 'Edit',
            enabled: canEditSelection,
            onClick: navigateToEditView
        },
        {
            label: 'Delete',
            enabled: canEditSelection,
            onClick: deleteGroup
        }
    ];

    this.paginationDefs = {
        paginationPrevPageHandler: paginationPreviousPageHandler,
        paginationNextPageHandler: paginationNextPageHandler,
        paginationPageSizeChanged: paginationPageSizeChanged,
        paginationJumpToPageHandler: getData,
        pagingOptions: PaginationService,
    };

    this.$onInit = () => {
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        this.isAdmin = PermissionsService.isAdmin();

        PaginationService.resetToDefaultValues();
        this.pagingOptions = PaginationService;
        NavbarUtilService.viewSearchFunction = getData;
        SearchFilterService.populateCriteriaFromLocationSearch();

        getData();
    };
}
angular.module('prism-ui.groups').component('groupsSearchView', {
    templateUrl: 'system/groups/searchView/groups-search-view-template.html',
    controller: GroupsSearchViewController,
    bindings: {
    }
});
